<app-page-header [title]="'Studio Details'" [subtitle]="'View details of the selected studio'"></app-page-header>

<!-- Studio Information -->
<h2 class="text-2xl font-semibold mb-2">Studio Information</h2>
<div class="mb-6 border border-gray-300 dark:border-gray-700 p-4 rounded-md">
    <div class="grid grid-cols-2 gap-2">
        <div class="flex flex-col gap-1">
            <p><strong>UUID:</strong> {{ studio?.uuid }}</p>
            <p><strong>Name:</strong> {{ studio?.name }}</p>
            <p><strong>Hostname:</strong> {{ studio?.hostname }}</p>
            <p><strong>RCPS Player ID:</strong> {{ studio?.rcpsPlayerId }}</p>
            <p><strong>Last Heartbeat:</strong> {{ studio?.lastHeartbeat | formatDateTime }}</p>
            <p><strong class="mr-2">State:</strong>
                <p-tag
                        [severity]="studio?.state === 'ONLINE' ? 'success' : studio?.state === 'OFFLINE' ? 'danger' : 'secondary'"
                        [value]="studio?.state | enumLabel"
                ></p-tag>
            </p>
            <p><strong>Created By:</strong> {{ studio?.createdBy | roleName }}</p>
            <p><strong>Updated By:</strong> {{ studio?.updatedBy | roleName }}</p>
        </div>
    </div>
</div>

<!-- Dealership Details -->
@if (studio?.dealership) {
    <div class="mb-6">
    <h2 class="text-2xl font-semibold mb-2">Dealership</h2>
    <div class="border border-gray-300 dark:border-gray-700 p-4 rounded-md">
        <div class="flex justify-between">
            <div>
                <p><strong>Name:</strong> {{ studio?.dealership?.name }}</p>
                <p><strong>GSSN:</strong> {{ studio?.dealership?.gssn }}</p>
                <p><strong>Country:</strong> {{ studio?.dealership?.country?.name }}</p>
            </div>
            <p-button
                    label="View Dealership"
                    icon="pi pi-eye"
                    routerLink="/dealerships/dealership/{{studio?.dealership?.id}}"
                    outlined
            ></p-button>
        </div>
    </div>
    </div>
}

<!-- Physical Samples -->
<div class="mb-6">
    <h2 class="text-2xl font-semibold mb-2">Physical Samples</h2>
    <div class="border border-gray-300 dark:border-gray-700 rounded-md overflow-hidden">
        <p-table
                (onLazyLoad)="onPhysicalSamplesPageChange($event)"
                [lazy]="true"
                [loading]="loadingPhysicalSamples"
                [paginator]="true"
                [rowsPerPageOptions]="[10, 25, 50]"
                [rows]="physicalSamplesRows"
                [totalRecords]="physicalSamplesTotalRecords"
                [value]="physicalSamples"
                dataKey="id"
                paginatorDropdownAppendTo="body"
        >
            <ng-template #header>
                <tr>
                    <th>MAC Address</th>
                    <th>State</th>
                    <th>Firmware</th>
                    <th>Battery</th>
                    <th>Sample</th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template #body let-physicalSample>
                <tr>
                    <td>{{ physicalSample.macAddress }}</td>
                    <td>
                        <p-tag
                                [severity]="physicalSample.state === 'ONLINE' ? 'success'
                                    : physicalSample.state === 'OFFLINE' ? 'danger'
                                    : 'secondary'"
                                [value]="physicalSample.state ? (physicalSample.state | enumLabel) : 'Unknown'"
                        ></p-tag>
                    </td>
                    <td>
                        <p-tag [value]="physicalSample.firmwareVersion || 'Unknown'"></p-tag>
                    </td>
                    <td>
                        <p-tag
                                [severity]="physicalSample.battery === 'FULL' || physicalSample.battery === 'HIGH' ? 'success'
                                    : physicalSample.battery === 'MEDIUM' ? 'info'
                                    : physicalSample.battery === 'LOW' ? 'warn'
                                    : physicalSample.battery === 'CRITICAL' ? 'danger'
                                    : 'secondary'"
                                [value]="physicalSample.battery ? (physicalSample.battery | enumLabel) : 'Unknown'"
                        ></p-tag>
                    </td>
                    <td>{{ physicalSample.sample?.printedName || '-' }}</td>
                    <td>
                        <p-button
                                icon="pi pi-eye"
                                pTooltip="View sample"
                                routerLink="/physical-samples/physical-sample/{{ physicalSample.id }}"
                                severity="secondary"
                                text
                        ></p-button>
                    </td>
                </tr>
            </ng-template>
            <ng-template #emptymessage>
                <tr>
                    <td class="text-center text-gray-500 py-4" colspan="6">No physical samples in this studio.</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>

<!-- Action Buttons -->
<div class="flex justify-between items-center mt-6">
    <div class="flex gap-3">
        <p-button (click)="openEditDialog()" icon="pi pi-pencil" isAdmin label="Edit" severity="secondary"
                  text></p-button>
        <p-button (click)="deleteStudio()" icon="pi pi-trash" isAdmin label="Delete" severity="danger" text></p-button>
    </div>
    <p-button label="Back to Studios" icon="pi pi-arrow-left" text routerLink="/studios"></p-button>
</div>

<!-- Update Dialog -->
<app-update-studio-dialog
        [(visible)]="displayUpdateDialog"
        [studio]="editableStudio"
        (studioUpdated)="reloadStudioDetails()"
></app-update-studio-dialog>
